import { render } from "./homescreen.vue?vue&type=template&id=6a5fa410&scoped=true"
import script from "./homescreen.vue?vue&type=script&lang=js"
export * from "./homescreen.vue?vue&type=script&lang=js"

import "@/styles/homescreen.css?vue&type=style&index=0&id=6a5fa410&scoped=true&lang=css"

import exportComponent from "C:\\Users\\eoladipo\\Documents\\Windows 10 Mock\\Windows10-mock\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a5fa410"]])

export default __exports__